import { Route, Routes } from "react-router-dom";

// Admin dashboard login
import {
  Login,
  ForgetPassword,
  ResetPassword,
  Dashboard,
  ViewProfile,
  EditProfile,
  ChangePassword,
  ChangeEmail,
  ListExercise,
  ExerciseReport,
  BiometricReport,
  FitnessReportPreviewsSummary,
  ListClient,
  ListCoach,
  ViewClientReport,
  CreateClientAccount,
  CreateCoachAccount,
  FitnessReportPreviewsDetailed,
  BiometricExerciseReport,
  NotFound,
} from "../pages";
import UnprotectedRoute from "../pages/UnprotectedRoute";
import ProtectedRoute from "../pages/ProtectedRoute";

export const coachRoutes = {
  dashboard: "/",
  login: "/login",
  forgetPassword: "/forget-password",
  resetPassword: "/reset-password/:token",
  viewProfile: "/view-profile",
  editProfile: "/edit-profile",
  changePassword: "/change-password",
  changeEmail: "/change-email",
  listCoach: "/list-coach",
  createCoachAccount: "/create-coach-account",
  listExercise: "/list-exercise",
  createBiometricExerciseReport: "/add-biometric-exercise-report",
  createBiometricExercise: "/add-biometric-exercise",
  createBiometricReport: "/add-biometric",
  fitnesReportPreviewsSummary: "/fitnes-report-preview-summary/:clientId",
  fitnesReportPreviewsDetailed:"/fitnes-report-preview-detailed/:clientId",
  listClient: "/list-client",
  viewClientReport: "/client-report/:clientId",
  createClientAccount: "/create-client-account",
};

const CoachRouter = () => {
  return (
    <Routes>
      <Route element={<UnprotectedRoute />}>
        <Route path={coachRoutes.login} element={<Login />} />
        <Route path={coachRoutes.forgetPassword} element={<ForgetPassword />} />
        <Route path={coachRoutes.resetPassword} element={<ResetPassword />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route path={coachRoutes.dashboard} element={<Dashboard />} />
        <Route path={coachRoutes.viewProfile} element={<ViewProfile />} />
        <Route path={coachRoutes.editProfile} element={<EditProfile />} />
        <Route path={coachRoutes.changePassword} element={<ChangePassword />} />
        <Route path={coachRoutes.changeEmail} element={<ChangeEmail />} />
        <Route
          path={coachRoutes.createCoachAccount}
          element={<CreateCoachAccount />}
        />
        <Route path={coachRoutes.listCoach} element={<ListCoach />} />
        <Route path={coachRoutes.listExercise} element={<ListExercise />} />
        <Route
          path={coachRoutes.createBiometricExerciseReport}
          element={<BiometricExerciseReport />}
        />
        <Route
          path={coachRoutes.createBiometricExercise}
          element={<ExerciseReport />}
        />
        <Route
          path={coachRoutes.createBiometricReport}
          element={<BiometricReport />}
        />
        <Route path={coachRoutes.listClient} element={<ListClient />} />
        <Route
          path={coachRoutes.viewClientReport}
          element={<ViewClientReport />}
        />
        <Route
          path={coachRoutes.fitnesReportPreviewsSummary}
          element={<FitnessReportPreviewsSummary />}
        />
        <Route
          path={coachRoutes.fitnesReportPreviewsDetailed}
          element={<FitnessReportPreviewsDetailed />}
        />
        <Route
          path={coachRoutes.createClientAccount}
          element={<CreateClientAccount />}
        />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default CoachRouter;
